import React, {useEffect, useState} from "react";
import axios from "../../axios/AxiosInstance";
import {apiErrorMessage} from "../../utils/apiError";

export default function ContractRequestEmailDetails({requestId}) {
 const [email,setEmail]=useState(null);
 const [error,setError]=useState("");
 const [retry,setRetry]=useState(0);
 useEffect(()=>{
  let active=true;
  const controller=new AbortController();
  setEmail(null);setError("");
  axios.get(`demande-contrat/freelance/planning/${requestId}`,{signal:controller.signal})
   .then(({data})=>{if(active)setEmail(data);})
   .catch(err=>{if(active)setError(apiErrorMessage(err,"Impossible de charger le récapitulatif de la demande."));});
  return ()=>{active=false;controller.abort();};
 },[requestId,retry]);
 if(error)return <div role="alert" className="rounded-lg border border-slate-200 p-4 text-sm text-slate-700">{error}<button type="button" onClick={()=>setRetry(value=>value+1)} className="ml-3 underline">Réessayer</button></div>;
 if(!email)return <p role="status" className="text-sm text-slate-500">Chargement du récapitulatif…</p>;
 return <section aria-label="Récapitulatif de l’email" className="space-y-4 border-t border-slate-200 pt-5">
  <h3 className="text-sm font-semibold text-slate-900">{email.status==="sent"?"Email envoyé à l’agence":"Récapitulatif de la demande"}</h3>
  <dl className="grid gap-2 text-xs text-slate-600">
   {email.to && <div><dt className="inline font-semibold">À : </dt><dd className="inline">{email.to}</dd></div>}
   {email.subject && <div><dt className="inline font-semibold">Objet : </dt><dd className="inline">{email.subject}</dd></div>}
   {email.status==="sent" && email.sentAt && <div><dt className="inline font-semibold">Envoyé le : </dt><dd className="inline">{new Date(email.sentAt).toLocaleString("fr-FR")}</dd></div>}
   {email.status!=="sent" && <p>{email.status==="failed"?"L’envoi de l’email a échoué.":"L’envoi de l’email n’est pas confirmé."}</p>}
  </dl>
  {email.text ? <div className="whitespace-pre-wrap break-words rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm leading-relaxed text-slate-700">{email.text}</div> : <p className="text-sm text-slate-500">Le récapitulatif email n’est pas disponible pour cette ancienne demande.</p>}
 </section>;
}
